import React, { useEffect, useState } from "react";
import snowflake from "../../../assets/icons/loading-snowflake.svg";
import CustomAlert from "../../CustomAlert";
import useFetch from "../../../services/functions/useFetch";

const Sessioncheck = () => {
  const [sessionData, setSessionData] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const { fetchData, isPending } = useFetch<string>();

  useEffect(() => {
    fetchData("/session", "GET", {
      doOnSuccess: (data: string) => {
        setSessionData(data);
      },
      doOnError: () => {
        setError("Failed to fetch session");
      },
    });
  }, []);

  return (
    <>
      {error && <CustomAlert message={error} type="error" />}
      {isPending ? (
        <img src={snowflake} alt="loading" className="loading-snowflake" />
      ) : (
        <section className="section-container">
          <div className="content-wrapper">
            <div className="form-container">
              <h1 className="form-title">Sessioncheck:</h1>
              <h1 className="form-title">{sessionData}</h1>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Sessioncheck;
